{
  "rightSidebar": {
    "placeholder": "This panel is a placeholder.",
    "chat": {
      "placeholder": "Ask about this workout…"
    },
    "favourites": {
      "empty": "Your most-used exercises will appear here once you log some workouts."
    },
    "tabs": {
      "coach": "Training Coach",
      "exercises": "Exercises",
      "favourites": "Favourites"
    }
  },
  "title": "Workouts",
  "subtitle": "Track your fitness journey",
  "builder": {
    "header": {
      "label": "Workout",
      "selectDate": "Select date"
    }
  },
  "status": {
    "planned": "Planned",
    "started": "In Progress",
    "finished": "Completed",
    "creating": "Creating"
  },
  "action": {
    "planned": "Start",
    "started": "Continue",
    "finished": "Done"
  },
  "progressCount": "{{completed}}/{{total}}",
  "empty": {
    "title": "No workouts planned",
    "description": "Start your fitness journey by creating your first workout"
  },
  "createWorkout": "Create Workout",
  "duration": "{{duration}}min",
  "exercises_one": "{{count}} exercise",
  "exercises_other": "{{count}} exercises",
  "progress": {
    "title": "Workout Progress",
    "loading": "Loading workout...",
    "workoutNotFound": "Workout not found",
    "comingSoon": "Progress tracking coming soon",
    "setsTitle": "Workout sets",
    "setsCompleted": "{{done}}/{{total}} completed",
    "setShort": "Set {{number}}",
    "setBadge": "SET"
  },
  "form": {
    "title": {
      "create": "Create New Workout",
      "edit": "Edit Workout",
      "detail": "Workout Detail"
    },
    "fields": {
      "name": {
        "label": "Workout Name",
        "placeholder": "Enter workout name"
      },
      "plannedAt": {
        "label": "Planned Date",
        "placeholder": "Select date"
      },
      "note": {
        "label": "Note",
        "placeholder": "Add a note..."
      }
    },
    "buttons": {
      "save": "Save Workout",
      "cancel": "Cancel",
      "create": "Create Workout",
      "update": "Update Workout",
      "addExercise": "Add Exercise",
      "addSuperset": "Add Superset",
      "startWorkout": "Start Workout",
      "stopWorkout": "Stop Workout"
    },
    "validation": {
      "nameRequired": "Workout name is required",
      "dateRequired": "Planned date is required"
    },
    "datePicker": {
      "selectDate": "Select date"
    }
  },
  "deleteConfirmation": {
    "description": "Are you sure you want to delete the workout '{{name}}'? This action cannot be undone."
  },
  "stopConfirmation": {
    "title": "Stop Workout",
    "description": "Are you sure you want to stop this workout? Your progress will be saved."
  },
  "superset": {
    "title": "Superset {{index}}",
    "label": "Superset",
    "moveUp": "Move Up",
    "moveDown": "Move Down",
    "delete": "Delete"
  },
  "sportActivitySelector": {
    "title": "Select Exercise",
    "description": "Choose an exercise to add to your workout",
    "searchPlaceholder": "Search exercises...",
    "resultsPlaceholder": "Search results will appear here",
    "noResults": "No exercises found",
    "loading": "Searching exercises...",
    "error": "Couldn't load exercises. Check your connection and try again.",
    "createCustom": "Create Custom Activity",
    "filters": {
      "all": "All"
    }
  },
  "createActivity": {
    "title": "Create Custom Sport Activity",
    "subtitle": "Create your own custom exercise",
    "fields": {
      "name": {
        "label": "Name *",
        "placeholder": "e.g., Bulgarian Split Squat"
      },
      "category": {
        "label": "Category *",
        "placeholder": "Select category"
      },
      "dimensions": {
        "label": "Tracked Metrics",
        "hint": "Select 1–3 metrics"
      },
      "muscleTargets": {
        "label": "Target Muscles",
        "hint": "At least one muscle",
        "targetNumber": "Target #{{number}}",
        "count_one": "{{count}} muscle",
        "count_other": "{{count}} muscles"
      },
      "muscleGroup": "Muscle Group",
      "muscle": "Muscle",
      "intensity": "Intensity"
    },
    "actions": {
      "cancel": "Cancel",
      "create": "Create Activity",
      "addMuscle": "Add muscle"
    }
  },
  "muscleGroup": {
    "ARMS": "Arms",
    "LEGS": "Legs",
    "CHEST": "Chest",
    "BACK": "Back",
    "SHOULDERS": "Shoulders",
    "CORE": "Core",
    "CARDIOVASCULAR": "Cardiovascular"
  },
  "muscle": {
    "BICEPS": "Biceps",
    "TRICEPS": "Triceps",
    "FOREARMS": "Forearms",
    "QUADRICEPS": "Quadriceps",
    "HAMSTRINGS": "Hamstrings",
    "CALVES": "Calves",
    "GLUTES": "Glutes",
    "PECTORALIS_MAJOR": "Pectoralis Major",
    "PECTORALIS_MINOR": "Pectoralis Minor",
    "LATISSIMUS_DORSI": "Latissimus Dorsi",
    "TRAPEZIUS": "Trapezius",
    "RHOMBOIDS": "Rhomboids",
    "DELTOIDS": "Deltoids",
    "ROTATOR_CUFF": "Rotator Cuff",
    "RECTUS_ABDOMINIS": "Rectus Abdominis",
    "OBLIQUES": "Obliques",
    "LOWER_BACK": "Lower Back",
    "HEART": "Heart"
  },
  "exercise": {
    "delete": "Delete",
    "swap": "Swap Exercise",
    "moveUp": "Move Up",
    "moveDown": "Move Down"
  },
  "sets": {
    "title": "Sets",
    "setNumber": "Set {{number}}",
    "noSets": "No sets added yet",
    "loading": "Loading sets...",
    "error": "Error loading sets"
  },
  "exerciseSummary": {
    "sets_one": "{{count}} set",
    "sets_other": "{{count}} sets",
    "reps": "reps"
  },
  "dimension": {
    "WEIGHT": {
      "name": "Weight"
    },
    "REPS": {
      "name": "Reps"
    },
    "TIME": {
      "name": "Time"
    },
    "DISTANCE": {
      "name": "Distance"
    },
    "CALORIES": {
      "name": "Calories"
    },
    "HEART_RATE": {
      "name": "Heart Rate"
    },
    "REST": {
      "name": "Rest"
    }
  },
  "sequence": {
    "title": "Workout Sequence",
    "subtitle": "{{count}} set in sequence",
    "subtitle_plural": "{{count}} sets in sequence",
    "loading": "Loading sequence...",
    "error": "Error loading sequence",
    "empty": "No sets to display in sequence",
    "supersetLabel": "Superset {{index}}",
    "exerciseLabel": "Exercise {{index}}",
    "completeSet": "Complete Set"
  },
  "exerciseLibrary": {
    "title": "My Exercises",
    "add": "Add",
    "empty": "No custom exercises yet",
    "custom": "Custom"
  },
  "personalRecords": {
    "title": "Personal Records",
    "reps_one": "{{count}} rep",
    "reps_other": "{{count}} reps",
    "empty": "No personal records yet"
  },
  "stats": {
    "title": "Weekly Summary",
    "workouts": "Workouts",
    "totalTime": "Total Time",
    "caloriesBurned": "Calories Burned",
    "weightLifted": "lbs Lifted"
  },
  "history": {
    "title": "Workout History",
    "thisWeek": "This Week",
    "today": "Today",
    "yesterday": "Yesterday",
    "empty": "No workouts this week",
    "add": "Add"
  },
  "unit": {
    "BPM": {
      "shortName": "bpm"
    },
    "H": {
      "shortName": "h"
    },
    "KCAL": {
      "shortName": "kcal"
    },
    "KG": {
      "shortName": "kg"
    },
    "KM": {
      "shortName": "km"
    },
    "LB": {
      "shortName": "lb"
    },
    "M": {
      "shortName": "m"
    },
    "MI": {
      "shortName": "mi"
    },
    "MIN": {
      "shortName": "min"
    },
    "NONE": {
      "shortName": ""
    },
    "S": {
      "shortName": "s"
    }
  },
  "summary": {
    "title": "Great job!",
    "subtitle": "{{name}} completed successfully",
    "stats": {
      "title": "Workout stats",
      "volume": "Volume load",
      "volumeCaption": "Σ (sets × reps × weight)",
      "duration": "Workout time",
      "durationUnit": "minutes"
    },
    "units": {
      "kg": "kg"
    },
    "difficulty": {
      "title": "How hard was it?",
      "levels": {
        "easy": "Easy",
        "ok": "OK",
        "right": "Right",
        "hard": "Hard",
        "max": "Max"
      }
    },
    "note": {
      "title": "Workout note",
      "placeholder": "How I feel after the workout, what I could improve…"
    },
    "done": "Back to overview"
  },
  "duplicate": {
    "action": "Duplicate",
    "actionsLabel": "Workout actions",
    "modal": {
      "title": "Duplicate workout",
      "description": "Pick a date for the new planned workout. The copy keeps every exercise and set with its planned values.",
      "dateLabel": "Planned date",
      "confirm": "Duplicate",
      "cancel": "Cancel"
    },
    "toast": {
      "title": "Workout duplicated",
      "description": "'{{name}}' was added to your plan."
    }
  },
  "recorded": {
    "effort": "Recorded effort",
    "avgHr": "Avg HR",
    "maxHr": "Max HR",
    "calories": "Calories",
    "fromSource": "Heart rate & calories from {{source}}",
    "sourceAppleHealth": "Apple Health",
    "sourceHealthConnect": "Health Connect",
    "match": {
      "confirmTitle": "Attach your recorded session?",
      "confirmSubtitle": "We found a session that overlaps this workout.",
      "pickTitle": "Which session was this?",
      "pickSubtitle": "A few activities overlap this workout — pick the one to attach.",
      "attach": "Attach",
      "attachSelected": "Attach selected",
      "notNow": "Not now",
      "range": "{{start}}–{{end}} · {{minutes}} min",
      "bpm": "{{bpm}} bpm",
      "kcal": "{{kcal}} kcal"
    }
  }
}
